// extracted by mini-css-extract-plugin
export default {"headerAction":"TableHeaderActions_headerAction__oTt19","refetchWrapper":"TableHeaderActions_refetchWrapper__nmoHJ"};